module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/message-95c27d6c7586d0dc972fd3929e092f20.svg";